import { yupResolver } from '@hookform/resolvers/yup'
import ImageTextPreview from 'Components/Common/ImageTextPreview'
import TruckingCommission from 'Components/Master/TruckingCommission'
import { apiBearer } from 'Helpers/api'
import {
  LIST_BANKS_URL,
  LIST_CITIES_URL,
  LIST_DISTRICTS_URL,
  LIST_PROVINCES_URL,
  LIST_VILLAGES_URL
} from 'Helpers/url_helper'
import { WarehouseRQ } from 'Hooks/Queries'
import { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Select from 'react-select'
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Container,
  Input,
  Label,
  Row
} from 'reactstrap'
import * as Yup from 'yup'
import BreadCrumb from '../../Components/Common/BreadCrumb'
import ErrorFieldWrapper from '../../Components/Common/ErrorFieldWrapper'
import { validNumbers } from 'Helpers/regex_validation'

let idd = 0

export default function EditCreateWarehouse(props) {
  const {id} = useParams()
  const navigate = useNavigate()

  const [province, setProvince] = useState(null)
  const [provinceOptions, setProvinceOptions] = useState([])
  const [city, setCity] = useState(null)
  const [cityOptions, setCityOptions] = useState([])
  const [district, setDistrict] = useState(null)
  const [districtOptions, setDistrictOptions] = useState([])
  const [village, setVillage] = useState(null)
  const [villageOptions, setVillageOptions] = useState([])
  const [bank, setBank] = useState(null)
  const [bankOptions, setBankOptions] = useState([])
  const [commissionDistribute, setCommissionDistribute] = useState([
    {id: idd++, name: '',type:'', value: ''},
  ])

  const onDeleteCommission = (id) => {
    setCommissionDistribute((prevs) => prevs.filter((prev) => prev.id !== id))
  }
  const onAddCommission = () => {
    setCommissionDistribute((prevs) => [
      ...prevs,
      {id: idd++, name: '', value: ''},
    ])
  }

  const onChangeValue = (field, id, value) => {
    setCommissionDistribute((prevs) =>
      prevs.map((prev) => {
        if (prev.id === id) {
          const payload = {}
          payload[field] = value
          return {...prev, ...payload}
        }
        return prev
      }),
    )
  }

  const validation = Yup.object().shape({
    code: Yup.string()
      .required('Code harus diisi')
      .matches(/^[a-zA-Z0-9]+$/, 'Code hanya boleh berisi hurung dan angka'),
    name: Yup.string().required('Name harus diisi'),
    picName: Yup.string().required('PIC Name harus diisi'),
    picEmail: Yup.string().required('PIC Email harus diisi'),
    picPhone: Yup.string().required('PIC Phone harus diisi').matches(validNumbers, {message:'Phone hanya boleh berisi angka'}),
    address: Yup.string().required('Address harus diisi'),
    bankAccount: Yup.string().required('Bank account harus diisi'),
    bank: Yup.string().required('Bank name harus diisi'),
    province: Yup.string().required('Province harus diisi'),
    city: Yup.string().required('City harus diisi'),
    district: Yup.string().required('District harus diisi'),
    village: Yup.string().required('Village harus diisi'),
    zipcode: Yup.string().required('Zipcode harus diisi').matches(validNumbers, {message:'Zip code hanya boleh berisi angka'}),
    // .test("required", "You need to provide a file", value => value && value.length > 0)
    doc:Yup.mixed(),
    logo: Yup.mixed(),
  })
  const formOptions = {
    resolver: yupResolver(validation),
    defaultValues: {
      code: '',
      name: '',
      picName: '',
      picEmail: '',
      picPhone: '',
      address: '',
      bankAccount: '',
      bank: '',
      province: '',
      city: '',
      district: '',
      village: '',
      zipcode: '',
      logo: '',
      doc: '',
    },
  }
  const {handleSubmit, formState, control, reset} =
    useForm(formOptions)
  const {errors} = formState

  const {mutate: updateWarehouse, isLoading: isLoadingUpdate} =
    WarehouseRQ.useUpdateFormData(navigate)()

  const getCommissionDistributePayload = () => {
    return commissionDistribute.map((item) => {
      if(item.type) delete item.type;
      if (typeof item.id === 'number') return {...item, id: null}
      else return item
    }).filter(v=>v.value)
  }

  const _updateWarehouse = (values) => {
    const data = JSON.stringify({
      code: values.code,
      name: values.name,
      province_id: values.province,
      city_id: values.city,
      district_id: values.district,
      village_id: values.village,
      address: values.address,
      zip_code: values.zipcode,
      pic_name: values.picName,
      pic_email: values.picEmail,
      pic_phone: values.picPhone,
      bank_account: values.bankAccount,
      bank_name: values.bank,
      commission_distribute: getCommissionDistributePayload(),
    })

    const body = new FormData()
    body.append('id', id)
    body.append('data', data)
    body.append('doc', values.doc)
    body.append('logo', values.logo)

    updateWarehouse(body)
  }

  const {mutate: addWarehouse, isLoading: isLoadingCreate} =
    WarehouseRQ.useAddData(navigate)()

  const _createWarehouse = async (values) => {
    const data = JSON.stringify({
      code: values.code,
      name: values.name,
      province_id: values.province,
      city_id: values.city,
      district_id: values.district,
      village_id: values.village,
      address: values.address,
      zip_code: values.zipcode,
      pic_name: values.picName,
      pic_email: values.picEmail,
      pic_phone: values.picPhone,
      bank_account: values.bankAccount,
      bank_name: values.bank,
    })

    const body = new FormData()
    body.append('data', data)
    body.append('doc', values.doc)
    body.append('logo', values.logo)

    addWarehouse(body)
  }

  const {
    data: detailData,
    error,
    isFetching,
    status,
  } = WarehouseRQ.useGetData(id)()

  useEffect(() => {
    if (!isFetching && status === 'success') {
      if (id) {
        onProvinceSelected({
          label: detailData.data?.province?.name,
          value: detailData.data?.province?.id,
        })
        onCitySelected({
          label: detailData.data?.city?.name,
          value: detailData.data?.city?.id,
        })
        onDistrictSelected({
          label: detailData.data?.district?.name,
          value: detailData.data?.district?.id,
        })
        setVillage({
          label: detailData.data?.village?.name,
          value: detailData.data?.village?.id,
        })
      }
      reset({
        code: detailData.data?.code ?? '',
        name: detailData.data?.name ?? '',
        picName: detailData.data?.pic_name ?? '',
        picEmail: detailData.data?.pic_email ?? '',
        picPhone: detailData.data?.pic_phone ?? '',
        address: detailData.data?.address ?? '',
        bankAccount: detailData.data?.bank_account ?? '',
        bank: detailData.data?.bank_name ?? '',
        province: detailData.data?.province?.id ?? '',
        city: detailData.data?.city?.id ?? '',
        district: detailData.data?.district?.id ?? '',
        village: detailData.data?.village?.id ?? '',
        zipcode: detailData.data?.zip_code ?? '',
      })

      if (
        detailData?.data?.commission &&
        detailData?.data?.commission_distributes &&
        detailData?.data?.commission_distributes.length > 0
      ) {
        setCommissionDistribute(
          detailData.data.commission_distributes.map((v) => ({
            ...v,
            type: {label: v.value_type, value:v.value_type},
          }))
        )
      } else {
        setCommissionDistribute([{id: null, name: '', value: ''}])
      }
    }
    if (!isFetching && status === 'error') {
      console.log(error)
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [status, isFetching])

  useEffect(() => {
    fetchProvinces()
    fetchBanks()
  }, [])

  useEffect(() => {
    if (id && detailData?.data?.bank_name && bankOptions.length > 0) {
      const selectedBank = bankOptions.find(
        (v) => v.value === detailData.data.bank_name,
      )
      if (selectedBank) setBank(selectedBank)
    }
  }, [detailData?.data?.bank_name, id, bankOptions])

  const fetchBanks = async () => {
    const result = await apiBearer.get(LIST_BANKS_URL)
    const {data} = result
    if (data.success) {
      setBankOptions(data.data.map((v) => ({label: v?.name, value: v.code})))
    }
  }

  const fetchProvinces = async (input) => {
    const result = await apiBearer.get(LIST_PROVINCES_URL + '?keyword=' + input)
    const {data} = result
    if (data.success) {
      setProvinceOptions(data.data.map((v) => ({label: v?.name, value: v?.id})))
    }
  }

  const onProvinceSelected = async (e) => {
    setProvince(e)
    if (e && e.value) {
      const result = await apiBearer.get(LIST_CITIES_URL(e.value))
      const {data} = result
      if (data.success) {
        setCityOptions(data.data.map((v) => ({label: v?.name, value: v?.id})))
      }
    } else {
      setCityOptions([])
      setDistrictOptions([])
      setVillageOptions([])
      setCity(null)
      setDistrict(null)
      setVillage(null)
    }
  }

  const onCitySelected = async (e) => {
    setCity(e)
    if (e) {
      const result = await apiBearer.get(LIST_DISTRICTS_URL(e.value))
      const {data} = result
      if (data.success) {
        setDistrictOptions(
          data.data.map((v) => ({label: v?.name, value: v?.id})),
        )
      }
    } else {
      setDistrictOptions([])
      setDistrict(null)
    }
  }

  const onDistrictSelected = async (e) => {
    setDistrict(e)
    if (e) {
      const result = await apiBearer.get(LIST_VILLAGES_URL(e.value))
      const {data} = result
      if (data.success) {
        setVillageOptions(
          data.data.map((v) => ({label: v?.name, value: v?.id})),
        )
      }
    } else {
      setVillageOptions([])
      setVillage(null)
    }
  }

  const calculateDistribute = () => {
    let total = 0;
    commissionDistribute.forEach(({value_type, value})=>{
      if(value_type === 'PERCENT') total += detailData?.data?.commission * ((value||0)/100);
      if(value_type === 'AMOUNT') total += parseInt(value||0);
    })
    return total
  }

  const isValueValid = 
  !detailData?.data?.commission || 
  (!!detailData?.data?.commission && 
    calculateDistribute() <= detailData?.data?.commission)


  return (
    <div className='page-content'>
      <Container fluid>
        <BreadCrumb title='Warehouse' pageTitle='Warehouse' />
        <Row>
          <Col lg={12}>
            <form
              onSubmit={handleSubmit(id ? _updateWarehouse : _createWarehouse)}
            >
              <Card>
                <CardHeader className='align-items-center d-flex'>
                  <h4 className='card-title mb-0 flex-grow-1'>
                    {id ? 'Edit' : 'Create'} Warehouse
                  </h4>
                </CardHeader>
                <CardBody className='card-body'>
                  <Row className='gy-4'>
                    <Col md={6}>
                      <ErrorFieldWrapper
                        error={errors?.code}
                        message={errors?.code?.message}
                      >
                        <Label htmlFor='code' className='form-label'>
                          Code
                        </Label>
                        <Controller
                          id='code'
                          name='code'
                          type='code'
                          control={control}
                          render={({field}) => (
                            <Input {...field} value={field.value} />
                          )}
                        />
                      </ErrorFieldWrapper>
                    </Col>
                    <Col md={6}>
                      <ErrorFieldWrapper
                        error={errors?.name}
                        message={errors?.name?.message}
                      >
                        <Label htmlFor='name' className='form-label'>
                          Name
                        </Label>
                        <Controller
                          id='name'
                          name='name'
                          type='name'
                          control={control}
                          render={({field}) => (
                            <Input {...field} value={field.value} />
                          )}
                        />
                      </ErrorFieldWrapper>
                    </Col>
                    <Col md={6}>
                      <ErrorFieldWrapper
                        error={errors.province}
                        message={errors.province?.message}
                      >
                        <Label htmlFor='province' className='form-label'>
                          Province
                        </Label>
                        <Controller
                          id='province'
                          name='province'
                          type='text'
                          control={control}
                          render={({field: {onChange, ...field}}) => (
                            <Select
                              {...field}
                              cacheOptions
                              isClearable
                              defaultOptions
                              value={province ?? ''}
                              options={provinceOptions}
                              onChange={(e) => {
                                if (e?.value) onChange(e.value)
                                onProvinceSelected(e)
                              }}
                              placeholder='Search by name'
                            />
                          )}
                        />
                      </ErrorFieldWrapper>
                    </Col>
                    <Col md={6}>
                      <ErrorFieldWrapper
                        error={errors.city}
                        message={errors.city?.message}
                      >
                        <Label htmlFor='city' className='form-label'>
                          City
                        </Label>
                        <Controller
                          id='city'
                          name='city'
                          type='text'
                          control={control}
                          render={({field: {onChange, ...field}}) => (
                            <Select
                              {...field}
                              cacheOptions
                              isClearable
                              defaultOptions
                              value={city ?? ''}
                              options={cityOptions}
                              onChange={(e) => {
                                if (e?.value) onChange(e.value)
                                onCitySelected(e)
                              }}
                              placeholder='Search by name'
                            />
                          )}
                        />
                      </ErrorFieldWrapper>
                    </Col>
                    <Col md={6}>
                      <ErrorFieldWrapper
                        error={errors.district}
                        message={errors.district?.message}
                      >
                        <Label htmlFor='district' className='form-label'>
                          District
                        </Label>
                        <Controller
                          id='district'
                          name='district'
                          type='text'
                          control={control}
                          render={({field: {onChange, ...field}}) => (
                            <Select
                              {...field}
                              cacheOptions
                              isClearable
                              defaultOptions
                              value={district ?? ''}
                              options={districtOptions}
                              onChange={(e) => {
                                if (e?.value) onChange(e.value)
                                onDistrictSelected(e)
                              }}
                              placeholder='Search by name'
                            />
                          )}
                        />
                      </ErrorFieldWrapper>
                    </Col>
                    <Col md={6}>
                      <ErrorFieldWrapper
                        error={errors.village}
                        message={errors.village?.message}
                      >
                        <Label htmlFor='village' className='form-label'>
                          Village
                        </Label>
                        <Controller
                          id='village'
                          name='village'
                          type='text'
                          control={control}
                          render={({field: {onChange, ...field}}) => (
                            <Select
                              {...field}
                              cacheOptions
                              isClearable
                              defaultOptions
                              value={village ?? ''}
                              options={villageOptions}
                              onChange={(e) => {
                                if (e?.value) onChange(e.value)
                                setVillage(e)
                              }}
                              placeholder='Search by name'
                            />
                          )}
                        />
                      </ErrorFieldWrapper>
                    </Col>
                    <Col md={6}>
                      <ErrorFieldWrapper
                        error={errors.zipcode}
                        message={errors.zipcode?.message}
                      >
                        <Label htmlFor='zipcode' className='form-label'>
                          Zipcode
                        </Label>
                        <Controller
                          id='zipcode'
                          name='zipcode'
                          type='zipcode'
                          control={control}
                          render={({field}) => (
                            <Input {...field} value={field.value} />
                          )}
                        />
                      </ErrorFieldWrapper>
                    </Col>
                    <Col md={6}>
                      <ErrorFieldWrapper
                        error={errors.picName}
                        message={errors.picName?.message}
                      >
                        <Label htmlFor='picName' className='form-label'>
                          PIC Name
                        </Label>
                        <Controller
                          id='picName'
                          name='picName'
                          type='picName'
                          control={control}
                          render={({field}) => (
                            <Input {...field} value={field.value} />
                          )}
                        />
                      </ErrorFieldWrapper>
                    </Col>
                    <Col md={6}>
                      <ErrorFieldWrapper
                        error={errors.picEmail}
                        message={errors.picEmail?.message}
                      >
                        <Label htmlFor='picEmail' className='form-label'>
                          PIC Email
                        </Label>
                        <Controller
                          id='picEmail'
                          name='picEmail'
                          type='picEmail'
                          control={control}
                          render={({field}) => (
                            <Input {...field} value={field.value} />
                          )}
                        />
                      </ErrorFieldWrapper>
                    </Col>
                    <Col md={6}>
                      <ErrorFieldWrapper
                        error={errors.picPhone}
                        message={errors.picPhone?.message}
                      >
                        <Label htmlFor='picPhone' className='form-label'>
                          PIC Phone
                        </Label>
                        <Controller
                          id='picPhone'
                          name='picPhone'
                          type='picPhone'
                          control={control}
                          render={({field}) => (
                            <Input {...field} value={field.value} />
                          )}
                        />
                      </ErrorFieldWrapper>
                    </Col>
                    <Col md={6}>
                      <ErrorFieldWrapper
                        error={errors.address}
                        message={errors.address?.message}
                      >
                        <Label htmlFor='address' className='form-label'>
                          Address
                        </Label>
                        <Controller
                          id='address'
                          name='address'
                          type='address'
                          control={control}
                          render={({field}) => (
                            <Input {...field} value={field.value} />
                          )}
                        />
                      </ErrorFieldWrapper>
                    </Col>
                    <Col md={6}>
                      <ErrorFieldWrapper
                        error={errors.bankAccount}
                        message={errors.bankAccount?.message}
                      >
                        <Label htmlFor='bankAccount' className='form-label'>
                          Bank Account
                        </Label>
                        <Controller
                          id='bankAccount'
                          name='bankAccount'
                          type='bankAccount'
                          control={control}
                          render={({field}) => (
                            <Input {...field} value={field.value} />
                          )}
                        />
                      </ErrorFieldWrapper>
                    </Col>
                    <Col md={6}>
                      <ErrorFieldWrapper
                        error={errors.bank}
                        message={errors.bank?.message}
                      >
                        <Label htmlFor='bank' className='form-label'>
                          Bank
                        </Label>
                        <Controller
                          id='bank'
                          name='bank'
                          control={control}
                          render={({field: {onChange, ...field}}) => (
                            <Select
                              {...field}
                              cacheOptions
                              isClearable
                              defaultOptions
                              value={bank ?? ''}
                              options={bankOptions}
                              onChange={(e) => {
                                if (e?.value) onChange(e.value)
                                setBank(e)
                              }}
                              placeholder='Search by name'
                            />
                          )}
                        />
                      </ErrorFieldWrapper>
                    </Col>
                    <Col md={6}>
                      <ErrorFieldWrapper
                        error={errors.logo}
                        message={errors.logo?.message}
                      >
                        <div className='d-flex justify-content-between'>
                          <Label htmlFor='logo' className='form-label'>
                            Logo{' '}
                          </Label>
                          {detailData?.data?.logo ? (
                            <ImageTextPreview link={detailData?.data?.logo} />
                          ) : null}
                        </div>
                        <Controller
                          id='logo'
                          name='logo'
                          control={control}
                          render={({field}) => (
                            <Input
                              className='form-control'
                              type='file'
                              onChange={(e) =>
                                field.onChange({
                                  target: {
                                    value: e.target.files[0],
                                    name: field?.name,
                                  },
                                })
                              }
                            />
                          )}
                        />
                      </ErrorFieldWrapper>
                    </Col>
                    <Col md={6}>
                      <ErrorFieldWrapper
                        error={errors.doc}
                        message={errors.doc?.message}
                      >
                        <div className='d-flex justify-content-between'>
                          <Label htmlFor='doc' className='form-label'>
                            DOKUMEN{' '}
                          </Label>
                          {detailData?.data?.doc ? (
                            <ImageTextPreview link={detailData?.data?.doc} />
                          ) : null}
                        </div>
                        <Controller
                          id='doc'
                          name='doc'
                          control={control}
                          render={({field}) => (
                            <Input
                              className='form-control'
                              type='file'
                              onChange={(e) =>
                                field.onChange({
                                  target: {
                                    value: e.target.files[0],
                                    name: field?.name,
                                  },
                                })
                              }
                            />
                          )}
                        />
                      </ErrorFieldWrapper>
                    </Col>
                  </Row>
                  {detailData?.data?.commission ? (
                    <TruckingCommission
                      label='COST CDO AFTER PPN'
                      onDelete={onDeleteCommission}
                      onAdd={onAddCommission}
                      onChangeValue={onChangeValue}
                      lists={commissionDistribute}
                      percent={detailData?.data?.commission}
                      isValueValid={isValueValid}
                    />
                  ) : null}
                </CardBody>
                <CardFooter className='align-items-center d-flex justify-content-end gap-3'>
                  <Link to='/app/warehouses' className='btn btn-danger'>
                    Cancel
                  </Link>
                  <Button
                    color='success'
                    type='submit'
                    disabled={isLoadingCreate || isLoadingUpdate || !isValueValid}
                  >
                    {isLoadingCreate || isLoadingUpdate
                      ? 'Loading...'
                      : id
                      ? 'Update'
                      : 'Create'}
                  </Button>
                </CardFooter>
              </Card>
            </form>
          </Col>
        </Row>
      </Container>
    </div>
  )
}
